import { type ConfigurableView } from '@air/api/types';

import { type DefaultBoardlessConfigViewsParams, getDefaultBoardlessConfigViews } from '~/constants/configViews';
import { BOARDLESS_CONFIG_VIEW } from '~/constants/localStorageKeys';

export class BoardlessConfigViewStore {
  private static instance: BoardlessConfigViewStore;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private constructor() {}

  static getInstance() {
    if (!BoardlessConfigViewStore.instance) {
      BoardlessConfigViewStore.instance = new BoardlessConfigViewStore();
    }
    return BoardlessConfigViewStore.instance;
  }

  private getBoardlessConfigViewKey = (pageId: string) => `${BOARDLESS_CONFIG_VIEW}-${pageId}`;

  public setSavedViewsForPage = (pageId: string, views: ConfigurableView[]) => {
    localStorage.setItem(this.getBoardlessConfigViewKey(pageId), JSON.stringify(views));
  };

  public getSavedViewsForPage = (
    pageId: string,
    defaultSort?: DefaultBoardlessConfigViewsParams['defaultSort'],
  ): ConfigurableView[] => {
    const savedViews = localStorage.getItem(this.getBoardlessConfigViewKey(pageId));
    return savedViews ? JSON.parse(savedViews) : getDefaultBoardlessConfigViews({ pageId, defaultSort });
  };

  public saveViewForPage = ({ pageId, view }: { pageId: string; view: ConfigurableView }) => {
    const savedViews = this.getSavedViewsForPage(pageId);
    const newViews = savedViews.map((v) =>
      v.id === view.id
        ? view
        : {
            ...v,
            isDefault: view.isDefault ? false : v.isDefault,
          },
    );

    localStorage.setItem(this.getBoardlessConfigViewKey(pageId), JSON.stringify(newViews));
  };
}
